import React from "react";

const Footer: React.FC = () => {
  const disclaimerData = [
    {
      title: "Disclaimer:",
      content:
        "This website is an advertising platform and is not intended to be a news publication, blog, or consumer protection update. The deals, offers, and coupon codes displayed on this site are subject to change without notice and may expire at any time. We do not guarantee the accuracy, completeness, or long-term validity of any information provided, including content found on third-party websites linked from this site.",
    },
    {
      title: "Marketing Disclosure:",
      content:
        "This website displays promotional information, including coupon codes and offers, provided by merchants or third-party sources. The website may maintain commercial relationships with some of the brands or platforms featured. However, this site does not provide purchase recommendations, usage examples, or transactional guidance, and users are responsible for verifying all offer details directly with the respective merchants.",
    },
    {
      title: "Advertising Disclosure:",
      content:
        "All products, services, and offers mentioned on this website are part of advertising and marketing programs. This website does not directly sell products or services and does not provide professional, legal, or financial advice. The content is provided solely for informational and comparison purposes to help users discover potential savings opportunities.",
    },
  ];
  return (
    <footer className="text-white w-full bg-[#1d1d1d]">
      <div className="m-auto grid grid-cols-1 md:grid-cols-2 mx-auto md:gap-10 md:max-w-[1300px] px-6 md:py-10 py-8">
        <div className="flex flex-col gap-6">
          <div className="text-2xl text-white font-bold cursor-pointer flex items-center">
            <img
              src="/images/codesseek-logo.png"
              alt=""
              className="w-9 h-9 mr-2 rounded-full"
            />
            <i>CodesSeek</i>
          </div>
          <div className="text-white font-medium text-sm opacity-80 md:opacity-90 mb-5">
            Regarding CodesSeek, we track online retailers' coupon codes to help
            consumers save money. When you make a purchase using our coupon
            link, please be sure to confirm the relevant coupon or promotion
            code on the retailer's website before buying, and verify its
            validity.
          </div>
        </div>
        <div className="w-full mt-2">
          <div className="w-full space-y-6">
            <div
              className="text-sm text-white/90 font-bold leading-5 md:text-base lg:text-lg"
              data-astro-cid-3o3bwxzc=""
            >
              Subscribe to our newsletter and get our newest updates right on
              your inbox.
            </div>
            <div className="mt-2.5 md:mt-5 flex gap-3 flex-wrap">
              <input
                id="email-input"
                type="email"
                placeholder="Enter your email"
                className="rounded-md flex-1 max-w-[245px] py-2 px-4 font-inter placeholder:text-textMain-100 outline-none text-textMain-500"
                data-astro-cid-3o3bwxzc=""
              />
              <button
                id="submit-button"
                className="w-[100px] h-10 text-base font-bold leading-5 text-textMain-0 border-0 cursor-pointer rounded-md bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 transition-all duration-300 px-3 shadow-sm hover:shadow-md"
                style={{ textShadow: "0px 2px 0px rgba(0, 0, 0, 0.2)" }}
                data-astro-cid-3o3bwxzc=""
              >
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2 mx-auto md:max-w-[1300px] px-6 pb-8">
        {disclaimerData.map((item) => (
          <div className="flex flex-col gap-2 text-white/90" key={item.title}>
            <h6 className="md:text-lg text-base font-bold">{item.title}</h6>
            <span className="md:text-sm text-sm">{item.content}</span>
          </div>
        ))}
      </div>
      <div className="bg-[#000] mt-4 py-2 px-6">
        <div className="font-medium md:max-w-[1260px] md:mt-0 bg-[#000] md:m-auto">
          <div className="py-4 grid grid-cols-1 md:grid-cols-2 mx-auto bg-slate-0">
            <div className="text-xs text-ellipsis line-clamp-1 md:text-base leading-4 font-medium">
              All Rights Reserved. | Privacy Policy
            </div>
            {/* <div className="text-xs md:text-end md:text-base leading-4 font-medium">
              All Rights Reserved. | Privacy Policy
            </div> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
